import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Store } from "@/lib/types";
import { PageHeader, StatusPill, LocalTime, LoadingBlock, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Store as StoreIcon } from "lucide-react";

import { useI18n } from "@/context/I18nContext";

export default function Stores() {
  const {
    t
  } = useI18n();

  const [stores, setStores] = useState<Store[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/org/stores")
      .then((r) => { setStores(r.data.stores); setTotal(r.data.total); })
      .catch(() => setStores([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    (<div>
      <PageHeader title="Stores" subtitle={`${total} store${total === 1 ? "" : "s"} in your scope`} testId="stores-header" />
      {loading ? <LoadingBlock /> : stores.length === 0 ? (
        <EmptyState icon={<StoreIcon size={28} />} title="No stores in your scope" />
      ) : (
        <Card className="overflow-hidden">
          <div className="hidden grid-cols-12 gap-3 border-b border-border bg-muted/50 px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground md:grid">
            <div className="col-span-1">#</div>
            <div className="col-span-4">{t("Store")}</div>
            <div className="col-span-3">{t("Location")}</div>
            <div className="col-span-2">{t("Local time")}</div>
            <div className="col-span-2">{t("Status")}</div>
          </div>
          {stores.map((s) => (
            <div key={s.id} data-testid={`store-row-${s.store_number}`}
              className="grid grid-cols-2 items-center gap-3 border-b border-border px-4 py-3 last:border-0 md:grid-cols-12">
              <div className="md:col-span-1 text-sm font-mono text-muted-foreground">{s.store_number}</div>
              <div className="md:col-span-4 font-medium">{s.name}</div>
              <div className="md:col-span-3 text-sm text-muted-foreground">
                {s.address?.city}{s.address?.state ? `, ${s.address.state}` : ""}
              </div>
              <div className="md:col-span-2 text-sm text-muted-foreground"><LocalTime tz={s.iana_tz} /></div>
              <div className="md:col-span-2"><StatusPill status={s.status} /></div>
            </div>
          ))}
        </Card>
      )}
    </div>)
  );
}
